import React from 'react';
import './BrandLogo.css';
import { PRODUCT_DISPLAY_NAME } from '../config/product';

/**
 * Product wordmark (GoDash / GoSuite) by GoBunnyy.
 * @param {'navbar' | 'auth' | 'compact'} variant
 */
const BrandLogo = ({ variant = 'navbar', className = '', decorative = false }) => {
  const isCompact = variant === 'compact';
  const productRest = PRODUCT_DISPLAY_NAME.replace(/^Go/, '') || 'Dash';

  return (
    <span
      className={`site-brand brand-logo brand-logo--${variant} ${className}`.trim()}
      {...(decorative ? { 'aria-hidden': true } : { 'aria-label': `${PRODUCT_DISPLAY_NAME} by GoBunnyy` })}
    >
      <span className="brand-stack">
        <span className="brand-wordmark brand-wordmark--product">
          <span className="brand-go">Go</span>
          <span className="brand-rest">{productRest}</span>
        </span>
        {!isCompact && (
          <span className="brand-byline">
            by{' '}
            <span className="brand-wordmark brand-wordmark--parent">
              <span className="brand-go">Go</span>
              <span className="brand-rest">Bunnyy</span>
            </span>
          </span>
        )}
      </span>
    </span>
  );
};

export default BrandLogo;
